const Joi = require("joi");

const loginSchema = (data) => {
  const schema = Joi.object({
    UserName: Joi.string()
      .trim()
      //.pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .required()
      // .max(30)
      .messages({
        //"string.pattern.base": "Please enter valid UserName.",
        // "string.max": "UserName Invalid.",
        "any.required": "Please enter Username.",
        "string.empty": "Please enter Username.",
      }),

    UserPassword: Joi.string()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .pattern(
        new RegExp(
          "^[A-Za-z\\d~!@#$%^&*()_+{}|:\\\"<>?\\[\\]\\\\\\-=\\;',./\\s]{8,}$"
        )
      )
      .required()
      // .max(30)
      .messages({
        "string.pattern.base": "Please enter valid Password.",
        // "string.max": "User Password must be less than 30 characters",
        "any.required": "Please enter Password.",
        "string.empty": "Please enter Password.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = loginSchema;
